import Swiper from 'swiper/bundle';


if ($('.slider-type-2').length) {
	$('.slider-type-2').each(function() {
		var $this = $(this);
		var section = $(this).closest('section');
		var pagination = section.find('.slider-pagination');
		window.sliderType2 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoHeight: false,
			autoplay: {
				delay: 4500,
				disableOnInteraction: false,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			loop: true,
			navigation: false,
			on: {
				init: function () {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')

					let maxHeight = 0;
					section.find('[data-slide-content] .block-content').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeight) {
							maxHeight = contentHeight;
						}
					});
					section.find('[data-slide-content] .block-content').css('height', maxHeight);

					let maxHeightRow = 0;
					section.find('[data-slide-content] .row').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeightRow) {
							maxHeightRow = contentHeight;
						}
					});
					// section.find('[data-slide-content] .row').css('height', maxHeightRow);
				},
				slideChangeTransitionStart: function (swiper) {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')
				},
			},
		});
	})
}




if ($('.slider-rental-gallery').length) {
	var galleryThumb = new Swiper(".slider-rental-gallery-thumb", {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			1024: {
				slidesPerView: 5,
			},
		},
	});
	var galleryBig = new Swiper(".slider-rental-gallery", {
		spaceBetween: 10,
		navigation: {
			nextEl: $('[data-gallery]').find('.swiper-button-next')[0],
			prevEl: $('[data-gallery]').find('.swiper-button-prev')[0],
		},
		thumbs: {
			swiper: galleryThumb,
		},
		hashNavigation: {
			watchState: true,
		},
		watchSlidesProgress: true,
		on: {
			init: function () {
				// console.log('swiper initialized');
			},
			slideChangeTransitionStart: function (swiper) {
				console.log()
				$('[data-gallery] .slider-progress .current').text(swiper.realIndex + 1);
			},
		},
	});
}


function initType3Slider() {
	$('.slider-type-3').each(function(index) {
		var slider = $(this);
		var offsetEl = slider.closest('section').find('.column-left > *');
		var offset = offsetEl.offset().left;
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.1,
			centeredSlides: false,
			spaceBetween: 14,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: false,
			scrollbar: false,
			navigation: false,
			slidesOffsetBefore: offset,
			slidesOffsetAfter: offset,
			navigation: {
				nextEl: slider.find('.swiper-button-next')[0],
				prevEl: slider.find('.swiper-button-prev')[0],
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.8,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1280: {
					slidesPerView: 2.5
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	});
}

if ($('.slider-type-3').length) {
	let lastWindowWidth = window.innerWidth;

	initType3Slider();

	let resizeTimeout;
	$(window).on('resize', function () {
		// Only act on horizontal resize
		if (window.innerWidth !== lastWindowWidth) {
			lastWindowWidth = window.innerWidth;

			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function () {
				initType3Slider();
			}, 300);
		}
	});
}

if ($('[data-section="galleryImages"]').length) {
	$('[data-section="galleryImages"]').each(function(index) {
		var slider = $(this).find('.slider-type-gallery');
		var prevArr = $(this).find('.swiper-button-prev')[0];
		var nextArr = $(this).find('.swiper-button-next')[0];
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		//ensure more than 5
		var $slides = slider.find('.swiper-slide');
		if ($slides.length < 6) {
			const needed = 6 - $slides.length;
			for (var i = 0; i < needed; i++) {
				const $slideToClone = $slides.eq(i % $slides.length);
				const $clone = $slideToClone.clone(true);
				slider.find('.swiper-wrapper').append($clone);
			}
		} 

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.25,
			centeredSlides: true,
			spaceBetween: 16,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: true,
			scrollbar: false,
			navigation: {
				nextEl: nextArr,
				prevEl: prevArr,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 1.75,
					spaceBetween: 32
				},
			},
		});
	});
}